export enum MutationAction {
  PATCH = 'PATCH',
  DELETE = 'DELETE',
  PUT = 'PUT',
  POST = 'POST',
}
